import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApp } from "@/state/AppContext";
import { api, apiErrorMessage } from "@/lib/api";

const GoogleMark = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path
      fill="#EA4335"
      d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2.5 24 .5 14.6.5 6.4 5.9 2.6 13.8l7.9 6.1C12.3 13.7 17.6 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.1 24.6c0-1.6-.1-2.8-.4-4.1H24v8.1h12.6c-.3 2.1-1.6 5.2-4.6 7.3l7.7 6c4.5-4.2 6.4-10.2 6.4-17.3z"
    />
    <path fill="#FBBC05" d="M10.5 28.1a14.5 14.5 0 0 1 0-8.2l-7.9-6.1a24 24 0 0 0 0 20.4l7.9-6.1z" />
    <path
      fill="#34A853"
      d="M24 47.5c6.2 0 11.5-2 15.4-5.6l-7.7-6c-2.1 1.4-4.8 2.3-7.7 2.3-6.4 0-11.7-4.2-13.5-10.1l-7.9 6.1C6.4 42.1 14.6 47.5 24 47.5z"
    />
  </svg>
);

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 * The return address is always built from window.location.origin.
 */
export const GoogleButton = ({ label, testId = "google-signin-btn" }) => {
  const { t, tenant } = useApp();
  // null = config not answered yet: hold the button's space so the page does not jump (RF-23).
  const [enabled, setEnabled] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get("/auth/google/config")
      .then(({ data }) => setEnabled(!!data.enabled))
      .catch(() => setEnabled(false));
  }, []);

  const start = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/google/start", {
        return_url: `${window.location.origin}/auth/google`,
        tenant_id: tenant?.id,
      });
      window.location.href = data.authorize_url;
    } catch (e) {
      toast.error(apiErrorMessage(e, t("errors.generic")));
      setLoading(false);
    }
  };

  if (enabled === null) return <div aria-hidden="true" className="h-[42px] w-full" />;
  if (!enabled) return null;

  return (
    <button
      type="button"
      data-testid={testId}
      disabled={loading}
      onClick={start}
      className="flex w-full items-center justify-center gap-3 rounded-full border border-border bg-white px-5 py-2.5 text-sm font-medium text-neutral-800 transition-colors hover:bg-neutral-50 disabled:opacity-60"
    >
      <GoogleMark />
      {loading ? t("common.loading") : label || t("auth.googleSignIn")}
    </button>
  );
};
